import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import truncate from 'lodash/truncate';
import Icon from '../../../../components/Icon';
import OutsideClickHandler from 'react-outside-click-handler';
import MilestoneSwitcher from '../MilestoneSwitcher';
import styles from './MilestoneInfo.m.sass';
var MilestoneInfo = function MilestoneInfo(_ref) {
  var state = _ref.state;
  var milestone = state.milestone;
  var percent = Math.round(state.completedTasksCount / Math.max(state.tasksCount, 1) * 100);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.buttonContainer
  }, /*#__PURE__*/React.createElement(OutsideClickHandler, {
    onOutsideClick: function onOutsideClick() {
      return state.closeMilestoneSwitcher();
    }
  }, /*#__PURE__*/React.createElement(SwitchButton, {
    title: milestone.title,
    isOpen: state.showingMilestoneSwitcher,
    onClick: function onClick() {
      return state.showingMilestoneSwitcher ? state.closeMilestoneSwitcher() : state.showMilestoneSwitcher();
    }
  }, truncate(milestone.title, {
    length: 40
  })), /*#__PURE__*/React.createElement(MilestoneSwitcher, {
    state: state
  }))), state.canCompleteMilestone ? /*#__PURE__*/React.createElement("p", {
    className: styles.progress
  }, state.completedTasksCount, " of ", state.tasksCount, " tasks completed |", ' ', percent, "% completed.") : /*#__PURE__*/React.createElement("p", {
    className: styles.lockedInfo,
    title: "Please complete \"".concat(state.nextMilestone.title, "\" first.")
  }, "Locked until", ' ', /*#__PURE__*/React.createElement(InfoLink, {
    title: "Go to ".concat(state.previousMilestone.title),
    onClick: function onClick() {
      return state.selectMilestone(state.previousMilestone);
    }
  }, state.previousMilestone.title), ' ', "is completed"));
};
export default observer(MilestoneInfo);
var SwitchButton = function SwitchButton(_ref2) {
  var title = _ref2.title,
    onClick = _ref2.onClick,
    children = _ref2.children,
    isOpen = _ref2.isOpen;
  return /*#__PURE__*/React.createElement("a", {
    className: styles.toggleBtn,
    title: title,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, children), /*#__PURE__*/React.createElement("span", {
    className: cx(styles.icon, isOpen && styles.isOpen)
  }, /*#__PURE__*/React.createElement(Icon, {
    size: 18,
    material: true,
    name: "keyboard arrow down"
  })));
};
var InfoLink = function InfoLink(_ref3) {
  var title = _ref3.title,
    children = _ref3.children,
    onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement("a", {
    className: styles.link,
    title: title,
    onClick: onClick
  }, children, ' ', /*#__PURE__*/React.createElement("span", {
    className: styles.linkIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    auto: true,
    material: true,
    name: "exit to app"
  })));
};
//# sourceMappingURL=index.js.map
